<template>
  <section id="page-charts">
    <div id="charts">
      <b-card>
        <b-row>
          <b-col>
            <b-button-toolbar>
              <b-button-group size="md">
                <b-button @click="setCurrent('line')" :variant="buttonVariant('line')">Linee</b-button>
                <b-button @click="setCurrent('column')" :variant="buttonVariant('column')">Barre</b-button>
                <b-button @click="setCurrent('carpet')" :variant="buttonVariant('carpet')">Carpet</b-button>
                <b-button @click="setCurrent('scatter')" :variant="buttonVariant('scatter')">Scatter</b-button>
                <b-button @click="setCurrent('radar')" :variant="buttonVariant('radar')">Radar</b-button>
                <b-button @click="setCurrent('pie')" :variant="buttonVariant('pie')">Torta</b-button>
                <b-button @click="setCurrent('slots')" :variant="buttonVariant('slots')">Fasce</b-button>
              </b-button-group>
            </b-button-toolbar>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button-toolbar>
              <b-input-group  size="sm" prepend="Campionamento">
                <b-form-select v-model="sampling" :options="samplingValues"></b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mx-1" prepend="Periodo">
                <div class="form-control">
                  <div v-if="['1', '15', '60', 'd', 'w'].includes(sampling)">
                    <date-pick v-model="fromDate"
                              :isDateDisabled="isDateDisabled"
                              :inputAttributes="{ readonly: true }"
                              :months="monthsNames"
                              :weekdays="daysNames"
                              :selectableYearRange="5"
                              :format="'DD/MM/YYYY'" />
                    -
                    <date-pick v-model="toDate"
                              :inputAttributes="{readonly: true}"
                              :months="monthsNames"
                              :weekdays="daysNames"
                              :selectableYearRange="5"
                              :format="'DD/MM/YYYY'" />
                  </div>
                  <div v-if="sampling == 'm'">
                    <vue-monthly-picker v-model="fromMonth"
                              :monthLabels="monthLabels"
                              :dateFormat="'MM/YYYY'" />
                    -
                    <vue-monthly-picker v-model="toMonth"
                              :monthLabels="monthLabels"
                              :dateFormat="'MM/YYYY'" />
                  </div>
                  <div v-if="sampling == 'y'" class="p-0">
                    <b-input-group size="sm" class="input-group-year">
                      <b-form-select v-model="fromYear" :options="yearOptions" class="mr-3"></b-form-select>
                      -
                      <b-form-select v-model="toYear" :options="yearOptions" class="ml-3"></b-form-select>
                    </b-input-group>
                  </div>
                </div>
              </b-input-group>
              <b-input-group size="sm" class="mx-1" prepend="Confronta" v-if="showCompare">
                <b-select v-model="compare">
                  <option value="no">--</option>
                  <option v-if="sampling != 'w'" value="previous">Periodo precedente</option>
                  <option v-if="sampling != 'w'" value="year">Anno precedente</option>
                  <option value="custom">Personalizzato</option>
                </b-select>
              </b-input-group>
              <b-input-group v-if="compare=='custom' && (current=='line' || current=='column')" size="sm" class="mx-1" prepend="Dal">
                <div class="form-control">
                  <div v-if="['1', '15', '60', 'd', 'w'].includes(sampling)">
                    <!--<date-pick v-model="compareFromDate"
                              :isDateDisabled="isFutureDate && isWeekAndIsNotMonday"
                              :inputAttributes="{ readonly: true }"
                              :months="monthsNames"
                              :weekdays="daysNames"
                              :format="'DD/MM/YYYY'" />-->
                    <date-pick v-model="compareFromDate"
                              :isDateDisabled="isWeekAndIsNotMonday"
                              :inputAttributes="{ readonly: true }"
                              :months="monthsNames"
                              :weekdays="daysNames"
                              :format="'DD/MM/YYYY'" />
                  </div>
                  <div v-if="sampling == 'm'">
                    <vue-monthly-picker v-model="compareFromMonth"
                              :monthLabels="monthLabels"
                              dateFormat="MM/YYYY" />
                  </div>
                </div>
              </b-input-group>
            </b-button-toolbar>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div>
              <b-alert variant="warning" :show="showWarning">Nessuna sorgente selezionata</b-alert>

              <div class="channel-filters" v-if="selectedSources.length > 0">
                <template v-for="(source, index) in selectedSources">
                  <VBadge 
                    :key="index"
                    :source="source"
                    @remove="removeSource(source)"
                  />
                  <!-- <b-badge v-if="source.type === 'parameter'" :key="index" class="mb-4">
                  {{ source.name }}
                  <font-awesome-icon @click="removeSource(source)" style="color:white;" icon="times" />
                  </b-badge> -->
                </template>
                <b-badge style="font-size: 14px;" variant="warning" class="remove-all mb-4" @click="clearAllSelectedSources">
                  Rimuovi tutti <font-awesome-icon style="color:black;" icon="times" />
                </b-badge>
              </div>
            </div>

            <line-chart v-if="current=='line'"
              :filter="filter"
              :reportpopupMode="reportMode"
              :is-need-update="isNeedUpdate"
              :selected-sources="selectedSources"
              @resetNeedingUpdate="resetNeedingUpdate"
              @aggregate-mode-changed="onAggregateModeChanged"
            ></line-chart>
            <line-chart v-if="current=='column'"
              type="bar"
              :filter="filter"
              :reportpopupMode="reportMode"
              :is-need-update="isNeedUpdate"
              :selected-sources="selectedSources"
              @resetNeedingUpdate="resetNeedingUpdate"
              @aggregate-mode-changed="onAggregateModeChanged"
            ></line-chart>
            <!-- <carpet-chart v-if="current=='carpet'"
                          :filter="filter"
                          :reportpopupMode="reportMode"
                          :is-need-update="isNeedUpdate"
                          @resetNeedingUpdate="resetNeedingUpdate"
                          @chart-image-uri="setImageURI"
            ></carpet-chart> -->
            <CarpetAmChart v-if="current=='carpet'"
                          :filter="filter"
                          :reportpopupMode="reportMode"
                          :is-need-update="isNeedUpdate"
                          @resetNeedingUpdate="resetNeedingUpdate"
                          @chart-image-uri="setImageURI"
            ></CarpetAmChart>
            <!-- <pie-chart v-if="current=='pie'"
                       :filter="filter"
                       :reportpopupMode="reportMode"
                       :is-need-update="isNeedUpdate"
                       @resetNeedingUpdate="resetNeedingUpdate"
                       @chart-image-uri="setImageURI"
            ></pie-chart> -->
            <PieAmChart v-if="current=='pie'"
                       :filter="filter"
                       :reportpopupMode="reportMode"
                       :is-need-update="isNeedUpdate"
                       @resetNeedingUpdate="resetNeedingUpdate"
                       @chart-image-uri="setImageURI"
            ></PieAmChart>
              <ScatterAmChart v-if="current=='scatter'"
                          :filter="filter"
                          :reportpopupMode="reportMode"
                          :is-need-update="isNeedUpdate"
                          @resetNeedingUpdate="resetNeedingUpdate"
                          @chart-image-uri="setImageURI"
            ></ScatterAmChart>
            <!-- <scatter-chart v-if="current=='scatter'"
                           :filter="filter"
                           :reportpopupMode="reportMode"
                           :is-need-update="isNeedUpdate"
                           @resetNeedingUpdate="resetNeedingUpdate"
                           @chart-image-uri="setImageURI"
            ></scatter-chart> -->
            <!-- <radar-chart v-if="current=='radar'"
                         :filter="filter"
                         :reportpopupMode="reportMode"
                         :is-need-update="isNeedUpdate"
                         @resetNeedingUpdate="resetNeedingUpdate"
                         @chart-image-uri="setImageURI"
            ></radar-chart> -->
            <RadarAmChart v-if="current=='radar'"
                         :filter="filter"
                         :reportpopupMode="reportMode"
                         :is-need-update="isNeedUpdate"
                         @resetNeedingUpdate="resetNeedingUpdate"
                         @chart-image-uri="setImageURI"
            ></RadarAmChart>
            <SlotsAm v-if="current=='slots'"
              type="bar"
              :filter="filter"
              :is-need-update="isNeedUpdate"
              @resetNeedingUpdate="resetNeedingUpdate"
            />
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <actions :filter="filter" :chartType="current" />
          </b-col>
        </b-row>
      </b-card>
    </div>
  </section>
</template>

<script>
import PageMixin from "./PageMixin";
import { mapState, mapActions } from 'vuex';
import VBadge from "./VBadge";
import vSelect from 'vue-select';

var moment = require('moment');

export default {
  components: {
    VBadge, vSelect,
  },

  props: {
    reportMode:{
      required: false,
      default: false,
    },
    reportSection: {
      required: false,
      default: null
    }
  },

  mixins: [PageMixin],

  data() {
    return {
      mode: 'MEASURES',
      fromDate: moment().subtract(1, 'months').format('DD/MM/YYYY'),
      toDate: moment().format('DD/MM/YYYY'),
      fromMonth: moment().subtract(1, 'months'),
      toMonth: moment(),
      fromYear: moment().subtract(1, 'years').format('yyyy'),
      toYear: moment().format('yyyy'),
      yearOptions: [],
    };
  },

  created() {
    for (let i = 2016; i <= parseInt(moment().format('yyyy').toString()); i++) {
      this.yearOptions.push({ text: i, value: moment(i.toString()).format('yyyy') });
    }
  }
}
</script>

<style>
.input-group-year {
  margin: -5px -27px 0 -6px;
}

.btn-toolbar .input-group .input-group-prepend .input-group-text {
  color: #1A1919;
  background: #7E827F;
}
.apexcharts-zoom-out-icon {
  margin-right: 30px;
}

.channel-filters {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}

.channel-filters span.badge {
  margin-right: 6px;
}
.channel-filters span.badge a {
  color: #ccc;
  text-decoration: none;
  position: relative;
  top: -4px;
}
.vdpPositionTop.vdpPositionLeft {
  z-index: 1000;
}
.channel-filters span.badge.remove-all {
  cursor: pointer;
}
.channel-filters span.badge.remove-all a {
  color: #333;
}
.channel-filters .remove-item-link {
  cursor: pointer;
}
.vue-monthly-picker .vmp-input-append{
  top: -10000px !important;
}
.main-chart {
  display: flex;
  flex-direction: row;
}

.main-chart .main-chart--expchild {
  flex: 0 1 auto;
}

.main-chart .main-chart--notexpchild {
  flex-grow: 1;
  max-height: 100%;
}
.side-pie-chart {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Page.vue